import React, { useState } from 'react';
import cx from 'classnames';
import withStyles from '@mui/styles/withStyles';
import Popover from '@mui/material/Popover';
import Icon from '@mui/material/Icon';
import Button from '@mui/material/Button';
import TableKey from './table/TableKey';
import { getOffices } from '../environment';

const BrandedTableKey = ({ classes }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const allOffices = getOffices();
    return (
        <>
            <Button className={cx(classes.capsuleContent, anchorEl && classes.capsuleContentOpen)}
                    onClick={evt => setAnchorEl(evt.currentTarget)}>
                Office&nbsp;Colours<Icon className={classes.tipContent}>keyboard_arrow_down</Icon>
            </Button>
            <Popover
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
                classes={{ paper: classes.capsuleContentPaper }}
            >
                <div className={classes.popContent}>
                    {allOffices.map(({ RegistrantSuffix }) => (
                        <TableKey key={RegistrantSuffix} legacyKey={RegistrantSuffix} />
                    ))}
                </div>
            </Popover>
        </>
    );
};

const styles = theme => ({
    popContent: {
        padding: '1rem 0 0.5rem 16px',
        [theme.breakpoints.down('md')]: {
            padding: '10px 0 10px 10px'
        }
    },
    tipContent: {
        fontSize: 16
    },
    capsuleContent: {
        fontSize: 12,
        paddingTop: 0,
        paddingBottom: 0,
        textTransform: 'unset',
        height: 10,
        lineHeight: 1
    },
    capsuleContentOpen: {
        background: '#d8d8d8',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
    },
    capsuleContentPaper: {
        borderTopLeftRadius: 0
    }
});
export default withStyles(styles)(BrandedTableKey);
